import { CASE_DATA_FILES, FILE_UPLOAD_ACTIONS } from "../type";

// Action Creators
export const addFilesToQueue = (files) => ({
    type: FILE_UPLOAD_ACTIONS.ADD_TO_QUEUE,
    payload: files, // Array of { id, file, fileName, caseId, caseRecordType, metaData }
});

export const startUpload = (uploadId) => ({
    type: FILE_UPLOAD_ACTIONS.START_UPLOAD,
    payload: { uploadId },
});

export const updateUploadProgress = (uploadId, progress) => ({
    type: FILE_UPLOAD_ACTIONS.UPDATE_PROGRESS,
    payload: { uploadId, progress }, // progress: 0-100
});

export const uploadSuccess = (uploadId, result) => ({
    type: FILE_UPLOAD_ACTIONS.UPLOAD_SUCCESS,
    payload: { uploadId, result }, // result: { signedUrl, uniqueKey, etc }
});

export const uploadFailed = (uploadId, error) => ({
    type: FILE_UPLOAD_ACTIONS.UPLOAD_FAILED,
    payload: { uploadId, error },
});

export const retryUpload = (uploadId) => ({
    type: FILE_UPLOAD_ACTIONS.RETRY_UPLOAD,
    payload: { uploadId },
});

export const cancelUpload = (uploadId) => ({
    type: FILE_UPLOAD_ACTIONS.CANCEL_UPLOAD,
    payload: { uploadId },
});

export const removeUpload = (uploadId) => ({
    type: FILE_UPLOAD_ACTIONS.REMOVE_UPLOAD,
    payload: { uploadId },
});

export const clearCompletedUploads = () => ({
    type: FILE_UPLOAD_ACTIONS.CLEAR_COMPLETED,
});

export const toggleUploadWidget = (isMinimized) => ({
    type: FILE_UPLOAD_ACTIONS.TOGGLE_WIDGET,
    payload: { isMinimized },
});

export const presignedUrlGenerationStart = (count) => ({
    type: FILE_UPLOAD_ACTIONS.PRESIGNED_URL_GENERATION_START,
    payload: { count }, // count: number of files starting presigned URL generation
});

export const presignedUrlGenerationComplete = (count) => ({
    type: FILE_UPLOAD_ACTIONS.PRESIGNED_URL_GENERATION_COMPLETE,
    payload: { count }, // count: number of files completed presigned URL generation
});

export const removeCaseDataFiles = (files) => ({
    type: CASE_DATA_FILES.REMOVE_FILES,
    payload: files,
});

export const updateCaseDataFile = (files) => ({
    type: CASE_DATA_FILES.UPDATE_FILE,
    payload: files,
});